var options = {
  message: "share this",
  // not supported on some apps (Facebook, Instagram)
  subject: "the subject",
  // fi. for email
  files: ["", ""],
  // an array of filenames either locally or remotely
  url: "https://www.npmjs.com/package/cordova-plugin-x-socialsharing" //     chooserTitle: 'Pick an app', // Android only, you can override the default share sheet title
  //     appPackageName: 'com.apple.social.facebook', // Android only, you can provide id of the App you want to share with
  //     iPadCoordinates: '0,0,0,0' //IOS only iPadCoordinates for where the popover should be point.  Format with x,y,width,height

};
import actions from "../js/actions.js";
import $$ from "Dom7";
export default {
  methods: {
    openAlert: function () {
      var self = this;
      self.$app.dialog.alert("Hello World");
    }
  },
  data: function () {
    return {
      LoginResult: actions.LoginGetResult()
    };
  },
  on: {
    pageInit: (e, page) => {
      var self = this; //   $$('#reservationstab').on('click', async () => {
      //     //app.f7.preloader.show();
      //     // wait for 3 seconds
      //     await new Promise(resolve => setTimeout(resolve, 3000));
      //     app.f7.views.main.router.navigate('/main/reservations/', { transition: 'f7-dive' })
      // });

      var logutdialog = app.f7.dialog.create({
        title: "",
        text: "Are you sure want to Logout?",
        buttons: [{
          text: "Cancel",
          cssClass: "dialogcancelbtn",
          onClick: function () {
            console.log("declined");
          }
        }, {
          text: "Logout",
          cssClass: "logoutbtn",
          onClick: function () {
            localStorage.clear();
            localStorage.setItem("showexitmessage", 1);
            console.log("LogOut");
            localStorage.removeItem("f7router-view_main-history");
            app.f7.views.main.router.navigate("/login/", {
              transition: "f7-dive"
            });
          }
        }]
      });

      function SocialSharing() {
        window.plugin.socialsharing.shareWithOptions(options);
      }

      $$("#ShareBtn").on("click", function () {
        //console.error("i am in");
        SocialSharing();
      });
      $$("#termsid").on("click", function () {
        //console.error("i am in");
        var url = "https://helpdesk-pms.abouthotelier.com/";
        window.cordova.InAppBrowser.open(url, "_self", "location=no"); //window.open(url, '_self');
      });
      $$("#logoutbtn").on("click", function () {
        logutdialog.open();
      });
      $$("#English").on("click", function () {
        const newLanguage = "en-US";
        localStorage.setItem("language", newLanguage);
        moment.locale(newLanguage);
        changeLocale(newLanguage);
        app.f7.views.main.router.refreshPage();
      });
      $$("#Greek").on("click", function () {
        const newLanguage = "el-GR";
        localStorage.setItem("language", newLanguage);
        changeLocale(newLanguage);
        moment.locale(newLanguage);
        app.f7.views.main.router.refreshPage();
      });
    }
  },
  id: '9666222fc4',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=settings><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i></a></div><div class="title sliding">Settings</div></div></div><div class=page-content><div class=accountdiv><span class="material-icons profileicon icons">account_circle</span><div class=item-inner style="display: inline-grid"><span class=useremail>';
      r += c(ctx_1.loginResult?.Email, ctx_1);
      r += ' </span><span>';
      r += c(ctx_1.loginResult?.Email, ctx_1);
      r += '</span></div></div><div class=list><ul><li><a href=/settingsnotifications/ class="item-content item-link"><span class="material-icons icons">notifications</span><div class=item-inner><div class=item-title>Notifications</div></div></a></li><li><a href=/settingsdnd/ class="item-content item-link"><span class="material-icons icons">do_not_disturb_on</span><div class=item-inner><div class=item-title>Do not Distrurb</div></div></a></li><li><a href=/settingsplan/ class="item-content item-link"><span class="material-icons icons">date_range</span><div class=item-inner><div class=item-title>Plan</div></div></a></li><!-- <li>\n          <a id="ShareBtn"  class="item-content item-link">\n            <span class="material-icons icons">\n              share\n              </span>\n            <div class="item-inner">\n              <div class="item-title">Share</div>\n            </div>\n          </a>\n        </li> --><li><a href=# id=termsid class="link item-content item-link"><span class="material-icons icons">insert_drive_file</span><div class=item-inner><div class=item-title>Terms of use</div></div></a></li><li><a href=# id=logoutbtn class="item-content item-link"><span class="material-icons icons">power_settings_new</span><div class=item-inner><div class=item-title>Logout</div></div></a></li></ul></div><div class=footer><span class=row>Version 1.0</span> <img class=footerlogoclass src=./static/images/abouthotelierlogo.png></div></div></div>';
      return r;
    }(this);
  },

  style: `
  .link.item-content.item-link a.link:before {
    content: '';
    width: auto !important;
  }

  .accountdiv {
    padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));
  }

  .accountdiv .profileicon {
    font-size: 35px !important;
    position: relative;
    top: 23px;
  }

  .footer {
    padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));
  }

  .icons {
    margin-right: 20px;
  }

  .footerlogoclass {
    margin-top: 10px;
    height: 2rem;
    width: auto;
  }

  .useremail {
    font-weight: 700;
  }

  .dialogcancelbtn {
    color: #eb4d3d;
  }

  .logoutbtn {
    color: #3478f6;
  }
`,
  styleScoped: false
};